import { ExpenseManagementTypes } from "./expenseManagementTypes";

export const initialState: ExpenseManagementTypes = {
  fetching: false,
  statusCode: null,
  error: null,
  success: null,
};
